"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var react_1 = require("react");
var fade_1 = __importDefault(require("@prezzee/fade"));
var Backdrop_style_1 = __importDefault(require("./Backdrop.style"));
var Backdrop = (0, react_1.forwardRef)(function (props, ref) {
    var children = props.children, className = props.className, _a = props.invisible, invisible = _a === void 0 ? false : _a, open = props.open, transitionDuration = props.transitionDuration, _b = props.TransitionComponent, TransitionComponent = _b === void 0 ? fade_1.default : _b, rest = __rest(props, ["children", "className", "invisible", "open", "transitionDuration", "TransitionComponent"]);
    return ((0, jsx_runtime_1.jsx)(TransitionComponent, __assign({ in: open, timeout: transitionDuration }, rest, { children: (0, jsx_runtime_1.jsx)("div", __assign({ css: (0, Backdrop_style_1.default)(invisible), "aria-hidden": true, className: className, ref: ref }, { children: children })) })));
});
exports.default = Backdrop;
//# sourceMappingURL=Backdrop.js.map